import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  row: {
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    '> *': {
      lineHeight: '24px',
    },
    '>div': {
      borderRight: `1px ${theme.palette.divider} solid`,
      padding: `${theme.spacing(3)} ${theme.spacing(2)}`,
    },
    alignContent: 'flex-start',
    alignItems: 'center',
  },
  textPaddingAfter: {
    paddingRight: theme.spacing(0.5),
  },
  highlightText: {
    color: theme.palette.info.main,
  },
}));

const PayeeTarget: React.FC<{ payeeTarget?: string }> = ({ payeeTarget }) => {
  const { cx, classes } = useStyles();

  return (
    <>
      {payeeTarget && (
        <Box className={classes.row}>
          <Typography className={classes.textPaddingAfter} variant='bodyRegular'>
            Rename as
          </Typography>
          <Typography className={cx(classes.textPaddingAfter, classes.highlightText)} variant='bodyMedium'>
            {payeeTarget}
          </Typography>
        </Box>
      )}
    </>
  );
};

export default PayeeTarget;
